import { CasesProvider } from "./Cases";
import { CategoriesProvider } from "./Categories";
import { PostsProvider } from "./Posts";
import { MediaProvider } from "./medias";

const Provider = ({ children }) => {
  return (
    <MediaProvider>
      <CasesProvider>
        <PostsProvider>
          <CategoriesProvider>{children}</CategoriesProvider>
        </PostsProvider>
      </CasesProvider>
    </MediaProvider>
  );
};

export default Provider;
